import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { DetailFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用の顧客詳細のフォームです。
 */
export const DetailForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>顧客詳細</FormLabel>
      <DetailFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
